import { Box, List, ListItem, Typography } from "@mui/material";
import React from "react";

export default function MentionsLegalesApp() {
  return (
    <Box sx={{ p: 3, maxWidth: "900px", mx: "auto", mt: 12 }}>
      <Typography variant="h4" gutterBottom>
        Conditions Générales d’Utilisation de l’application « Indice Fossile »
      </Typography>
      <Typography variant="body2" gutterBottom>
        Dernière mise à jour le 14 juillet 2025
      </Typography>

      <Typography variant="h6" mt={4}>
        1. Préambule
      </Typography>
      <Typography paragraph>
        L’application mobile Indice Fossile (ci-après « l’Application ») est
        éditée par l’association loi 1901 Indice Fossile, dont le siège est
        situé 50 allée Charles de Fitte (31300 Toulouse), immatriculée sous le
        n° W313038394, représentée par son Président MICHEL Victor, son
        Trésorier SANCHEZ Ricardo et sa Secrétaire HANNA Liliah.
      </Typography>

      <Typography variant="h6" mt={4}>
        2. Objet
      </Typography>
      <Typography paragraph>
        Les présentes CGU définissent les modalités et conditions d’utilisation
        de l’Application qui permet d’accéder à des informations sur l’impact
        environnemental des produits de consommation, notamment les émissions de
        gaz à effet de serre (CO₂e).
      </Typography>

      <Typography variant="h6" mt={4}>
        3. Acceptation des CGU
      </Typography>
      <Typography paragraph>
        L’accès et l’utilisation de l’Application impliquent l’acceptation des
        présentes CGU. En cas de désaccord, l’Utilisateur doit s’abstenir
        d’utiliser l’Application.
      </Typography>

      <Typography variant="h6" mt={4}>
        4. Accès à l’Application
      </Typography>
      <Typography paragraph>
        L’Application est gratuite et accessible via Internet. Certaines
        fonctionnalités sont réservées aux utilisateurs inscrits ou abonnés à
        l’offre Premium (version hors-ligne).
      </Typography>

      <Typography variant="h6" mt={4}>
        5. Inscription et Compte Utilisateur
      </Typography>
      <Typography paragraph>
        L’inscription est nécessaire pour certaines fonctionnalités.
        L’Utilisateur s’engage à fournir des informations exactes et à préserver
        la confidentialité de ses identifiants.
      </Typography>

      <Typography variant="h6" mt={4}>
        6. Fonctionnalités proposées
      </Typography>
      <List>
        <ListItem>Scan de produits (empreinte carbone, scores)</ListItem>
        <ListItem>Visualisation de l’empreinte carbone personnelle</ListItem>
        <ListItem>Catalogue pour préférences alimentaires</ListItem>
        <ListItem>
          Fonctionnalités Premium : mode hors-ligne, conseils personnalisés
        </ListItem>
      </List>
      <Typography paragraph>
        Voir :{" "}
        <a href="https://indicefossile.fr/application">
          indicefossile.fr/application
        </a>
      </Typography>

      <Typography variant="h6" mt={4}>
        7. Données personnelles
      </Typography>
      <Typography paragraph>
        Conformité RGPD. Données collectées : identification, localisation,
        caméra, consommation. Utilisation : anonyme, sécurisée, aucun transfert
        hors UE sans garantie.
      </Typography>
      <Typography paragraph>
        DPO : jeanloup.debeauminy@indicefossile.fr – Contact :
        contact@indicefossile.fr
      </Typography>

      <Typography variant="h6" mt={4}>
        8. Propriété intellectuelle
      </Typography>
      <Typography paragraph>
        Tous les contenus sont la propriété de l’Association. Toute reproduction
        ou exploitation est interdite sans autorisation écrite préalable.
      </Typography>

      <Typography variant="h6" mt={4}>
        9. Responsabilité
      </Typography>
      <Typography paragraph>
        L’Application repose sur des données publiques. Aucune garantie
        d’absence d’erreurs. L’Utilisateur assume les risques liés à
        l’utilisation. L’Association n’est pas responsable des bugs, erreurs
        d’analyse ou décisions fondées sur les données.
      </Typography>

      <Typography variant="h6" mt={4}>
        10. Services tiers
      </Typography>
      <Typography paragraph>
        Aucun service tiers utilisé actuellement. Toute future intégration sera
        mentionnée dans une mise à jour des CGU.
      </Typography>

      <Typography variant="h6" mt={4}>
        11. Suspension et résiliation
      </Typography>
      <Typography paragraph>
        L’Association peut suspendre l’accès sans préavis en cas de manquement.
        L’Utilisateur peut demander la suppression de son compte à
        contact@indicefossile.fr.
      </Typography>

      <Typography variant="h6" mt={4}>
        12. Droit applicable
      </Typography>
      <Typography paragraph>
        Les présentes CGU sont régies par le droit français. Tout litige sera
        soumis aux tribunaux compétents de Toulouse.
      </Typography>
    </Box>
  );
}
